/* istanbul ignore file */

import 'config/interceptors';
import {
  duckTheme,
  duckAlertApp,
  duckStatusLoading,
  duckStatusLoadingGrid,
  duckOpenModal,
  duckOpenModalJustificativa,
  duckSetReloadCaptcha,
  duckOpenModalAcessoNegado,
  duckOpenModalUsuarioPendente,
  duckDadosMinimizados,
  duckOpenModalEncaminhar,
  duckOpenModalCor,
} from '../ducks/app';
import { openNotification } from 'components/Notification';
import { ALERTA, ENUM_MODAL, STORAGE_THEME_FAS } from 'utils/consts';
import { openNotificationDebug } from 'components/NotificationDebug';
import { getEnv } from 'config/enviroment';

export const fetchStatusLoading = status => {
  return dispatch => {
    dispatch(duckStatusLoading(status));
  };
};

export const fetchStatusLoadingGrid = status => {
  return dispatch => {
    dispatch(duckStatusLoadingGrid(status));
  };
};

export const fetchAlertApp = alert => {
  return dispatch => {
    dispatch(duckAlertApp(alert));
  };
};

export const fetchNotificationApp = (
  titulo,
  mensagem = '',
  tipo = ALERTA.INFO,
  posicao = 'bottomRight',
  tempoExibir = 5,
  response = null
) => {
  openNotification(titulo, mensagem, tipo, posicao, tempoExibir, response);
};

export const fetchUpdateDadosMinimizados = novosDados => {
  return dispatch => {
    dispatch(duckDadosMinimizados(novosDados));
  };
};

export const fetchStatusModal = (status, title, props = {}) => {
  return dispatch => {
    dispatch(duckOpenModal({ isOpen: status, title: title, props: props }));
  };
};

export const fetchStatusModalJustificativa = (status, isSetorial, titleModal = null) => {
  let modalTitle = isSetorial ? ENUM_MODAL.JUSTIFICATIVA.USUARIO_SETORIAL : ENUM_MODAL.JUSTIFICATIVA.USUARIO_FRENTE;
  return dispatch => {
    dispatch(duckOpenModalJustificativa({ isOpen: status, title: titleModal || modalTitle }));
  };
};

export const fetchStatusModalEncaminhar = (status, title, props = {}) => {
  return dispatch => {
    dispatch(duckOpenModalEncaminhar({ isOpen: status, title: title, props: props }));
  };
};

export const fetchStatusModalAcessoNegado = (status, title, props = {}) => {
  return dispatch => {
    dispatch(duckOpenModalAcessoNegado({ isOpen: status, title: title, props: props }));
  };
};

export const fetchStatusModalUsuarioPendente = (status, title, props = {}) => {
  return dispatch => {
    dispatch(duckOpenModalUsuarioPendente({ isOpen: status, title: title, props: props }));
  };
};

export const fetchStatusModalCor = (status, title) => {
  return dispatch => {
    dispatch(duckOpenModalCor({ isOpen: status, title: title }));
  };
};

export const fetchSetReloadCaptcha = reload => {
  return dispatch => {
    dispatch(duckSetReloadCaptcha(reload));
  };
};

export const fetchUpdateTheme = theme => dispatch => {
  dispatch(duckTheme(theme));
  localStorage.setItem(STORAGE_THEME_FAS, theme);
};

export const fetchNotificationDebug = (mensagem = '', response = null) => {
  console.log(`◉ [DEBUG]:`, mensagem);
  if (getEnv()?.DEBUG) {
    openNotificationDebug('DEBUG', mensagem, ALERTA.AVISO, 'topLeft', 10, response);
  }
};
